import type {
  CycleType,
  PhaseType,
} from "@src/packages/cycles/hooks/useCycles";

const RETRIEVAL_BASED_CYCLE_TYPES = new Set<CycleType>([
  "ivf",
  "icsi",
  "egg_freezing",
  "embryo_freezing",
]);

const POST_RETRIEVAL_PHASE_TYPES = new Set<PhaseType>([
  "egg_retrieval",
  "fertilization",
  "embryo_development",
]);

/**
 * Retrieval-based procedures share the same post-retrieval Home: IVF/ICSI,
 * egg freezing, and embryo freezing all wait on laboratory processing after
 * the retrieval event. Keeping this rule separate makes it hard for a new
 * procedure-specific active Home to accidentally take precedence in that
 * window.
 *
 * The retrieval phase is current from the morning of its date, so the phase
 * alone moved her to recovery before the retrieval had happened, taking the
 * retrieval card with it. `retrievalStillAhead` keeps her on the active Home
 * until the retrieval is recorded or the day is over.
 */
export function isPostRetrievalPhase({
  cycleType,
  currentPhase,
  isInTreatment,
  retrievalStillAhead,
}: {
  cycleType: CycleType | undefined;
  currentPhase: PhaseType | undefined;
  isInTreatment: boolean;
  /** See `isRetrievalStillAhead`. */
  retrievalStillAhead: boolean;
}): boolean {
  return (
    isInTreatment &&
    !retrievalStillAhead &&
    cycleType !== undefined &&
    RETRIEVAL_BASED_CYCLE_TYPES.has(cycleType) &&
    currentPhase !== undefined &&
    POST_RETRIEVAL_PHASE_TYPES.has(currentPhase)
  );
}
